<template>
    <AuthenticatedLayout>
        <h1>Деньги</h1>

        <ConfirmDialog></ConfirmDialog>
        <Toast position="top-center" />

        <Card>
            <template #content>

                <div class="text-2xl mb-4">Кошельки</div>
                <div class="mb-4">
                    <div class="flex flex-row mb-2">
                        <div class="text-xl w-12rem">Торговый кошелёк:</div>
                        <div class="text-xl ml-4">${{wallet.basic}}</div></div>
                    <div class="text-gray-500">Средства, доступные боту для торговли. Сумму можно изменить в <a class="link" href="/settings">настройках</a>.</div>
                </div>
                <div class="mb-4">
                    <div class="flex flex-row align-items-center mb-2">
                        <div class="text-xl w-12rem">Сейф:</div>
                        <div class="text-xl ml-4">${{wallet.safe}}</div>
                        <div class="ml-4"><Button label="Переместить средства в торговый кошелёк" class="p-button-outlined p-button-sm" @click="handleClearSafe()" /></div>
                    </div>
                    <div class="text-gray-500">В сейф добавляется прибыль от всех сделок. Данные средства не участвуют в торговле.</div>
                </div>
                <div class="mb-4">
                    <div class="flex flex-row align-items-center mb-2">
                        <div class="text-xl w-12rem">Открытые сделки:</div>
                        <div class="text-xl ml-4">${{openDealsData.value}}</div>
                        <div class="ml-2">(сделок: {{openDealsData.count}} профит, если продавать сейчас: {{openDealsData.profit}})</div>
                    </div>
                    <div class="text-gray-500">Сколько денег находится сейчас в сделках. Монеты переведены в USDT по текущему рыночному курсу.</div>
                </div>
                <div class="mb-1">
                    <div class="flex flex-row align-items-center mb-2">
                        <div class="text-xl w-12rem">Итого:</div>
                        <div class="text-xl ml-4">${{totalWalletValue}}</div>
                    </div>
                    <div class="text-gray-500"></div>
                </div>
                <div class="mb-4">
                    <div class="flex flex-row align-items-center mb-2">
                        <div class="text-base w-12rem">Binance USDT:</div>
                        <div class="text-base ml-4"><span v-if="isBinanceConnected">${{binanceUSDT}}</span><span v-else>неизвестно</span></div>
                    </div>
                    <div class="text-gray-500"></div>
                </div>

                <div class="text-2xl mt-8 mb-2">Активные монеты на Binance</div>
                <div v-if="isBinanceConnected" class="flex flex-row">
                    <div class="flex-1">
                        <Datatable :value="availablePairs" :styles="{'min-width': '10px'}" :rowHover="true">
                            <Column>
                                <template #body="{data}">
                                    <div class="w-7rem">
                                    <SpinnerWrapper :loading="isDisablePair === data.symbol">
                                        <Button v-if="data.symbol !== 'USDT'" label="отключить" class="p-button-danger p-button-text" @click="handleDisablePair(data.symbol)"/>
                                    </SpinnerWrapper>
                                    </div>
                                </template>
                            </Column>
                            <Column field="symbol" header="Монета"></Column>
                            <Column field="available" header=""></Column>
                            <Column field="usdt_value" header="USDT"></Column>
                            <Column header="Сделок">
                                <template #body="slotProps">
                                    <div v-if="slotProps.data.num_deals > 0">{{slotProps.data.num_deals}}</div>
                                </template>
                            </Column>
                            <Column>
                                <template #body="slotProps">
                                    <div v-if="slotProps.data.symbol !== 'USDT'">
                                        <span class="cursor-pointer text-blue-500" @click="handleSell(slotProps.data.symbol, slotProps.data.available)">конвертация в USDT</span>
                                    </div>
                                </template>
                            </Column>
                            <ColumnGroup type="footer" v-if="availablePairs.length > 0">
                                <Row>
                                    <Column></Column>
                                    <Column></Column>
                                    <Column></Column>
                                    <Column :footer="sumAvailableUsdt"></Column>
                                    <Column></Column>
                                    <Column></Column>
                                </Row>
                            </ColumnGroup>
                        </Datatable>
                    </div>
                    <div class="flex-1"></div>
                </div>
                <div v-else>
                    <p class="text-red-500">Связь с Binance не установлена.</p>
                </div>


                <div class="text-2xl mt-8 mb-2">Отключённые монеты</div>
                <p class="my-2">
                    Монеты из этого списка не используются ботом и не участвуют в подсчётах денежного баланса. Если вы держите какие-нибудь монеты как инвест - добавляйте их сюда.
                </p>
                <div v-if="isBinanceConnected" class="flex flex-row">
                    <div class="flex-1">
                        <Datatable :value="disabledPairs" styles="{'min-width': '10px'}" :rowHover="true">
                            <Column :styles="{'min-width': '3rem'}">
                                <template #body="{data}">
                                    <Button label="вернуть" class="p-button-danger p-button-text" @click="handleEnablePair(data.symbol)"/>
                                </template>
                            </Column>
                            <Column field="symbol" header="Монета"></Column>
                            <Column field="available" header=""></Column>
                            <Column field="usdt_value" header="USDT"></Column>
                            <Column header="Сделок">
                                <template #body="slotProps">
                                    <div v-if="slotProps.data.num_deals > 0">{{slotProps.data.num_deals}}</div>
                                </template>
                            </Column>
                            <Column>
                                <template #body="slotProps">
                                    <div v-if="slotProps.data.symbol !== 'USDT'">
                                        <span class="cursor-pointer text-blue-500" @click="handleSell(slotProps.data.symbol, slotProps.data.available)">конвертация в USDT</span>
                                    </div>
                                </template>
                            </Column>
                            <ColumnGroup type="footer" v-if="disabledPairs.length > 0">
                                <Row>
                                    <Column></Column>
                                    <Column></Column>
                                    <Column></Column>
                                    <Column :footer="sumDisabledUsdt"></Column>
                                    <Column></Column>
                                    <Column></Column>
                                </Row>
                            </ColumnGroup>
                        </Datatable>
                    </div>
                    <div class="flex-1"></div>
                </div>
                <div v-else>
                    <p class="text-red-500">Связь с Binance не установлена.</p>
                </div>




            </template>
        </Card>

    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import Card from "primevue/card";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import SpinnerWrapper from "@/Components/SpinnerWrapper";
import InputSwitch from "primevue/inputswitch";
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import Datatable from "primevue/datatable";
import Column from "primevue/column";
import ProgressSpinner from "primevue/progressspinner";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import helperMethods from "@/helpers"

export default {
    components:{
        Row, ColumnGroup, ProgressSpinner,
        InputSwitch,
        AuthenticatedLayout,
        Card, InputText, Dropdown, Button, SpinnerWrapper, ConfirmDialog, Toast, Datatable, Column
    },
    props:{
        user: Object,
        availablePairs: Array,
        disabledPairs: Array,
        unknownPairs: Array,
        wallet: Object,
        isBinanceConnected: Boolean,
        openDealsData: Array,
        totalWalletValue: Number,
    },
    data(){
        return {
            isDisablePair: null,
            isEnablePair: null,
        }
    },
    watch:{
        flash(newFlash, oldFlash){
            if(newFlash.success !== null){
                this.$toast.add({severity:'success', summary: 'Success', detail: newFlash.success, life: 3000});
            }
            if(newFlash.error !== null){
                this.$toast.add({severity:'error', summary: 'Error', detail: newFlash.error, life: 5000});
            }
        }
    },
    computed:{
        sumAvailableUsdt(){
            let sum = 0;
            this.availablePairs.forEach((pair) => {
                sum += pair.usdt_value;
            });
            return "$"+this.round(sum, 2);
        },
        sumDisabledUsdt(){
            let sum = 0;
            this.disabledPairs.forEach((pair) => {
                sum += pair.usdt_value;
            });
            return "$"+this.round(sum, 2);
        },
    },
    methods:{
        ...helperMethods,
        handleSell(symbol, sum)
        {
            this.$confirm.require({
                message: 'Все сделки будут удалены, в статистику работы бота результат продажи не попадёт. ' + sum +' '+ symbol + ' будет сконвертировано в USDT по текущему рыночному курсу. Продолжить?',
                header: 'Подтверждение',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.$inertia.post(`/settings/sell/`, {symbol, sum}, {
                        onSuccess: (page) => {

                        }
                    });
                },
                reject: () => {

                }
            });

        },
        handleDisablePair(symbol){
            this.$confirm.require({
                message: 'Отключить эту монету ? Боты на этой монете будут выключены, деньги не будут участвовать в подсчётах.',
                header: 'Подтверждение',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.isDisablePair = symbol;
                    this.$inertia.post(`/money/disable_pair/`, {symbol}, {
                        onSuccess: (page) => {
                            this.isDisablePair = null;
                        }
                    });
                },
                reject: () => {

                }
            });
        },
        handleEnablePair(symbol){
            this.$confirm.require({
                message: 'Вернуть эту монету в работу? Боты нужно будет включить вручную.',
                header: 'Подтверждение',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.isEnablePair = symbol;
                    this.$inertia.post(`/money/enable_pair/`, {symbol}, {
                        onSuccess: (page) => {
                            this.isEnablePair = null;
                        }
                    });
                },
                reject: () => {

                }
            });
        },
        handleClearSafe(){
            this.$confirm.require({
                message: 'Переместить средства из сейфа в торговый кошелёк ?',
                header: 'Подтверждение',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.isClearSafe = true;
                    this.$inertia.post(`/money/clear_safe/`, {symbol}, {
                        onSuccess: (page) => {
                            this.isClearSafe = false;
                        }
                    });
                },
                reject: () => {

                }
            });
        }
    }

}
</script>
